import React, { useEffect, useState } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@mui/material";
import Layout from "../../components/Wrappers/Layout";
import { FormControl } from "@mui/material";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import { Card, Alert } from "reactstrap";
import { Row, Col } from "reactstrap";
import Box from "@mui/material/Box";
import { AiOutlineSearch } from "react-icons/ai";
import { NavLink, Link, useHistory, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Route, useLocation } from "react-router-dom";
import BackButton from "../../components/BackButton/BackButton";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
//import md5 from "md5";
import {
	resetInvoiceRegeneration,
	invoiceRegeneration
} from "../../redux/actions/invoiceRegenerationAction";
import {
	resetGetOrderId,
	getOrderId
} from "../../redux/actions/getOrderIdAction";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import { getInvoicesCofig } from "../../redux/actions/getInvoiceConfigAction";

const GetActionDetails = () => {
	const dispatch = useDispatch();

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	var authToken = regenerateTokenRes.data.AuthToken;

	const getInvoiceRes = useSelector(({ getInvoice }) => getInvoice);

	const loginRes = useSelector(({ login }) => login);

	const getInvoiceConfigRes = useSelector(
		({ getInvoiceConfig }) => getInvoiceConfig
	);

	const getOrderIdRes = useSelector(({ getOrderId }) => getOrderId);

	var invoiceRegenerationRes = useSelector(
		({ invoiceRegeneration }) => invoiceRegeneration
	);

	const location = useLocation();
	var memberID = location.search.split("=")[1];

	const abc = {
		memberId: "190669",
		statusInvoiceResult: {
			code: "00013",
			description: "Invoice regenerated successfully"
		},
		invoiceDetails: {
			amount: "52.50",
			currency: "USD",
			expirationPeriod: "0",
			createdDate: "2023-02-10",
			createdTime: " 16:18:31.",
			merchantInvoiceId: "PZ1219063810009",
			customerEmail: "savitha.m@paymentz.com",
			merchantOrderDescription: "Tshirt",
			systemInvoiceId: "26"
		}
	};

	const [invoiceDetailsArray, setInvoiceDetailsArray] = useState("");
	const [invoiceRegenerationStatus, setInvoiceRegenerationStatus] =
		useState(false);
	const [invoiceRegenerationArray, setInvoiceRegenerationArray] = useState([]);
	// const [getOrderIdStatus, setGetOrderIdStatus] = useState(false)
	const [notificationOpen, setNotificationOpen] = React.useState(false);

	const navigate = useHistory();
	const getRegenerateInvoice = () => {
		navigate.push({
			pathname: `/index/getRegenerateInVoice`
			//   search: `?userId=${id}`,
		});
	};

	useEffect(() => {
		dispatch(resetInvoiceRegeneration());
		getOrderIdReq();
	}, []);

	const getOrderIdReq = () => {
		let req = { authentication: { memberId: memberID } };
		dispatch(getOrderId(req, authToken));
	};

	// const verificationHash = md5(
	//   invoiceDetailsArray.systemInvoiceId +
	//   "|" +
	//   invoiceDetailsArray.memberId +
	//   "|" +
	//   loginRes.data.SKey +
	//   "|" +
	//   getInvoiceConfigRes.data.invoiceDetails.redirectUrl
	// );

	// console.log(verificationHash, "verificationHash")

	const getInvoiceDetailsFunc = (memberID) => {
		if (getInvoiceRes.success == true) {
			getInvoiceRes.data.invoiceList.map((item) => {
				if (item.memberId == memberID) {
					// console.log(item);
					setInvoiceDetailsArray(item);
				}
			});
		}
		if (getInvoiceRes.success == false) {
			setInvoiceDetailsArray(getInvoiceRes.data);
			// NotificationPopups(
			//   "error",
			//   "Failed",
			//   getInvoiceRes.data.statusInvoiceResult.description
			// );
		}
	};

	useEffect(() => {
		if (memberID != "") {
			getInvoiceDetailsFunc(memberID);
		}
	}, [getInvoiceRes.success]);

	const invoiceRegenerationReq = () => {
		setInvoiceRegenerationStatus(true);
		const req = {
			invoiceId: invoiceDetailsArray.systemInvoiceId,
			authentication: {
				memberId: invoiceDetailsArray.memberId
				// checksum: ""
			},
			merchantRedirectUrl: getInvoiceConfigRes.data.invoiceDetails.redirectUrl,
			merchantInvoiceId:
				getOrderIdRes.data.invoiceDetails.merchantOrderId.replace("_", "") ||
				"",
			// merchantInvoiceId: "PZ1219063810009",
			invoiceExpirationPeriod: invoiceDetailsArray.expirationPeriod
		};
		dispatch(invoiceRegeneration(req, authToken));
	};

	const invoiceRegenerationFunc = () => {
		if (invoiceRegenerationStatus) {
			if (invoiceRegenerationRes.success) {
				setInvoiceRegenerationArray(invoiceRegenerationRes.data);
				setNotificationOpen(true);
			}
			if (invoiceRegenerationRes.failed) {
				setInvoiceRegenerationArray(invoiceRegenerationRes.data);
				// NotificationPopups(
				//   "error",
				//   "Failed",
				//   invoiceRegenerationRes.data.statusInvoiceResult.description
				// );
				setNotificationOpen(true);
			}
		}
	};

	useEffect(() => {
		// if (invoiceRegenerationRes.success) {
		invoiceRegenerationFunc();
		// }
	}, [invoiceRegenerationRes]);

	const merchantConfigurationReq = (memberID) => {
		const req = {
			authentication: {
				memberId: memberID
			}
		};
		dispatch(getInvoicesCofig(req, authToken));
	};

	useEffect(() => {
		merchantConfigurationReq(memberID);
	}, [memberID]);

	const handleNoticationClose = () => {
		setNotificationOpen(false);
		navigate.push({
			pathname: `/index/merchantInvoice`
		});
	};

	return (
		<>
			<Layout>
				<BackButton />
				<div
					style={{
						background: "white",
						paddingTop: "1rem",
						borderRadius: "5px"
					}}
				>
					<Box marginLeft={3} marginRight={3} paddingBottom={2}>
						<Typography
							variant="h6"
							component="div"
							className="themeText"
							style={{
								fontSize: "1.4rem",
								marginBottom: "3.2rem",
								// color: "#013c83",
								textAlign: "center"
							}}
						>
							Invoice Regeneration Confirmation
						</Typography>

						<Row>
							<Col md={12}>
								<Row className="detail-info row">
									<Col
										md={6}
										style={{
											fontSize: "15px"
										}}
									>
										Order Id
									</Col>
									<Col md={6}>{invoiceDetailsArray.orderId}</Col>
								</Row>
								<hr />
								<Row className="detail-info row">
									<Col
										md={6}
										style={{
											fontSize: "15px"
										}}
									>
										Order Description
									</Col>
									<Col md={6}>{invoiceDetailsArray.orderDescription}</Col>
								</Row>
								<hr />
								<Row className="detail-info row">
									<Col
										md={6}
										style={{
											fontSize: "15px"
										}}
									>
										Order Amount
									</Col>
									<Col md={6}>{invoiceDetailsArray.amount}</Col>
								</Row>
								<hr />
								<Row className="detail-info row">
									<Col
										md={6}
										style={{
											fontSize: "15px"
										}}
									>
										Customer Email Id
									</Col>
									<Col md={6}>
										{invoiceDetailsArray &&
											invoiceDetailsArray.customerDetails &&
											invoiceDetailsArray.customerDetails.customeremail}
									</Col>
								</Row>
								<hr />
								<Row className="detail-info row">
									<Col
										md={6}
										style={{
											fontSize: "15px"
										}}
									>
										Customer Address
									</Col>
									<Col md={6}>
										{invoiceDetailsArray &&
											invoiceDetailsArray.customerDetails &&
											invoiceDetailsArray.customerDetails.customeraddress}
									</Col>
								</Row>
								<hr />
								<Row className="detail-info row">
									<Col
										md={6}
										style={{
											fontSize: "15px"
										}}
									>
										Customer City
									</Col>
									<Col md={6}>-</Col>
								</Row>
								<hr />
								<Row className="detail-info row">
									<Col
										md={6}
										style={{
											fontSize: "15px"
										}}
									>
										Customer State
									</Col>
									<Col md={6}>-</Col>
								</Row>
								<hr />
								<Row className="detail-info row">
									<Col
										md={6}
										style={{
											fontSize: "15px"
										}}
									>
										Customer Country
									</Col>
									<Col md={6}>-</Col>
								</Row>
								<hr />
								<Row className="detail-info row">
									<Col
										md={6}
										style={{
											fontSize: "15px"
										}}
									>
										Customer Zip Code
									</Col>
									<Col md={6}>-</Col>
								</Row>
								<hr />
								<Row className="detail-info row">
									<Col
										md={6}
										style={{
											fontSize: "15px"
										}}
									>
										Customer Phone No
									</Col>
									<Col md={6}>
										{" "}
										{invoiceDetailsArray &&
											invoiceDetailsArray.customerDetails &&
											invoiceDetailsArray.customerDetails.customermobileno}{" "}
									</Col>
								</Row>
								<hr />
								<Row className="detail-info row">
									<Col
										md={6}
										style={{
											fontSize: "15px"
										}}
									>
										Customer Redirect URL
									</Col>
									<Col md={6}> -</Col>
								</Row>
								<hr />
							</Col>
						</Row>
					</Box>
					<Grid
						container
						style={{
							padding: "10px",
							marginTop: "1.5rem",
							marginBottom: "15px"
						}}
					>
						<Grid item md={4}></Grid>
						<Grid item md={4}>
							{/* <Button
                style={{
                  marginLeft: "0.7rem",
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                // endIcon={<AiOutlineSearch />}
                variant="contained"
                onClick={invoiceRegenerationReq}
              >
                Click to Re-Generate Invoice
              </Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={invoiceRegenerationReq}
							>
								Click to Re-Generate Invoice
							</CustomButton>
						</Grid>
						<Grid item md={4}></Grid>
					</Grid>
				</div>
			</Layout>

			{invoiceRegenerationArray.statusInvoiceResult &&
				(invoiceRegenerationArray.statusInvoiceResult.description ==
				"Invoice regenerated successfully" ? (
					<div>
						<Dialog open={notificationOpen} onClose={handleNoticationClose}>
							<DialogContent
								className="text-center"
								style={{ backgroundColor: "#00b9f51c" }}
							>
								<img src={success} alt="" width="100px" className="my-2" />
							</DialogContent>
							<DialogContent>
								<p style={{ margin: "0", fontSize: "14px" }}>
									Invoice No. :{" "}
									{invoiceRegenerationArray.invoiceDetails.systemInvoiceId}
								</p>
								<p style={{ margin: "0", fontSize: "14px" }}>
									Date : {invoiceRegenerationArray.invoiceDetails.createdDate}
								</p>
								<p style={{ margin: "0", fontSize: "14px" }}>
									Invoice Sent To :{" "}
									{invoiceRegenerationArray.invoiceDetails.customerEmail}
								</p>
								<p
									style={{ margin: "0", fontSize: "15px", textAlign: "center" }}
								>
									Invoice Details
								</p>
								<p style={{ margin: "0", fontSize: "14px" }}>
									Order ID:{" "}
									{invoiceRegenerationArray.invoiceDetails.merchantInvoiceId}
								</p>
								<p style={{ margin: "0", fontSize: "14px" }}>
									Order Description :{" "}
									{
										invoiceRegenerationArray.invoiceDetails
											.merchantOrderDescription
									}
								</p>
								<p style={{ margin: "0", fontSize: "14px" }}>
									Order Amount: {invoiceRegenerationArray.invoiceDetails.amount}{" "}
									{invoiceRegenerationArray.invoiceDetails.currency}
								</p>
								<h4
									style={{
										margin: "0",
										textAlign: "center",
										fontSize: "17px",
										marginTop: "15px"
									}}
								>
									{invoiceRegenerationArray.statusInvoiceResult.description}
								</h4>
							</DialogContent>
							<DialogActions style={{ justifyContent: "center" }}>
								{/* <Button
									style={{
										margin: "10px 0",
										backgroundColor: "#00b9f5",
										color: "white"
									}}
									variant="contained"
									onClick={handleNoticationClose}
								>
									Ok
								</Button> */}
								<CustomButton
									style={{
										padding: "8px"
									}}
									onClick={handleNoticationClose}
									// endIcon={<SaveIcon />}
								>
									Ok
								</CustomButton>
							</DialogActions>
						</Dialog>
					</div>
				) : (
					<div>
						<Dialog open={notificationOpen} onClose={handleNoticationClose}>
							<DialogContent
								className="text-center"
								style={{ backgroundColor: "#00b9f51c" }}
							>
								<img src={failed} alt="" width="100px" className="my-2" />
							</DialogContent>
							<DialogContent>
								{/* <p style={{ margin: "0", fontSize: "14px" }}>Invoice No. : {abc.invoiceDetails.systemInvoiceId}</p>
            <p style={{ margin: "0", fontSize: "14px" }}>Date : {abc.invoiceDetails.createdDate}</p>
            <p style={{ margin: "0", fontSize: "14px" }}>Invoice Sent To : {abc.invoiceDetails.customerEmail}</p>
            <p style={{ margin: "0", fontSize: "15px", textAlign: "center" }}>Invoice Details</p>
            <p style={{ margin: "0", fontSize: "14px" }}>Order ID: {abc.invoiceDetails.merchantInvoiceId}</p>
            <p style={{ margin: "0", fontSize: "14px" }}>Order Description : {abc.invoiceDetails.merchantOrderDescription}</p>
            <p style={{ margin: "0", fontSize: "14px" }}>Order Amount: {abc.invoiceDetails.amount} {abc.invoiceDetails.currency}</p> */}
								<h4
									style={{
										margin: "0",
										textAlign: "center",
										fontSize: "17px",
										marginTop: "15px"
									}}
								>
									{invoiceRegenerationArray.statusInvoiceResult.description}
								</h4>
							</DialogContent>
							<DialogActions style={{ justifyContent: "center" }}>
								{/* <Button
									style={{
										margin: "10px 0",
										backgroundColor: "#00b9f5",
										color: "white"
									}}
									variant="contained"
									onClick={handleNoticationClose}
								>
									Ok
								</Button> */}
								<CustomButton
									style={{
										padding: "8px"
									}}
									onClick={handleNoticationClose}
									// endIcon={<SaveIcon />}
								>
									Ok
								</CustomButton>
							</DialogActions>
						</Dialog>
					</div>
				))}

			{/* {invoiceRegenerationRes.failed && (
        <div>
          <Dialog open={notificationOpen} onClose={handleNoticationClose}>
            <DialogContent
              className="text-center"
              style={{ backgroundColor: "#00b9f51c" }}
            >
              <img src={failed} alt="" width="100px" className="my-2" />
            </DialogContent>
            <DialogContent>
              <h4
                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
              >
                {invoiceRegenerationArray.statusInvoiceResult.description}
              </h4>
            </DialogContent>
            <DialogActions style={{ justifyContent: "center" }}>
              <Button
                style={{
                  margin: "10px 0",
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                variant="contained"
                onClick={handleNoticationClose}
              >
                Ok
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )} */}
		</>
	);
};

export default GetActionDetails;
